import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AsyncThunkConfig } from '../../async-thunk-config';
import { HomeError } from '../home';
import apiManager from '../../../api/api-manager';
import { getAPIRequestHeaders } from '../../../utils/api-utils';

export interface OpenIdState {
  status: string;
  ssoMobile?: boolean;
}

export const openidSSO = createAsyncThunk<
  void,
  void,
  AsyncThunkConfig<HomeError>
>('openid-sso', async (_, thunkApi) => {
  try {
    await apiManager.marketplaceApi.postSso(
      {
        email: thunkApi.getState().data.user.email,
      },
      getAPIRequestHeaders(thunkApi)
    );
    return null;
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const openidPreLogin = createAsyncThunk<
  void,
  void,
  AsyncThunkConfig<HomeError>
>('openid-pre-login', async (_, thunkApi) => {
  try {
    await apiManager.marketplaceApi.postPreLogin(
      {
        email: thunkApi.getState().data.user.email,
      },
      getAPIRequestHeaders(thunkApi)
    );
    return null;
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

const initialState: OpenIdState = {
  status: 'idle',
};

const openidSlice = createSlice({
  name: 'features/openid',
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(openidSSO.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(openidSSO.fulfilled, (state) => {
      state.ssoMobile = true;
    });
    builder.addCase(openidSSO.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(openidPreLogin.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(openidPreLogin.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(openidPreLogin.rejected, (state) => {
      state.status = 'failed';
    });
  },
});
export const { reset } = openidSlice.actions;

export default openidSlice.reducer;
